<template>
    <v-container >
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <h1 class="mb-3 heading deep-purple--text text--accent-3">Kravas</h1>
                </v-flex>

                <v-spacer></v-spacer>

                <v-flex xs10 sm4 >
                    <v-text-field
                            @input="searchCargos"
                            v-model="search"
                            append-icon="search"
                            label="Meklēt"
                            single-line
                            color="deep-purple accent-3"
                            class="mb-2"
                    ></v-text-field>
                </v-flex>
                <v-flex v-if="!showForm" xs2 sm1 class="pt-2 text-xs-right">
                    <v-tooltip top>
                        <v-btn  @click="showAddCargoForm" small outline fab color="deep-purple" slot="activator">
                            <v-icon >add</v-icon>
                        </v-btn>
                        <span>Pievienot kravu</span>
                    </v-tooltip>
                </v-flex>
                <v-flex v-if="showForm" xs2 sm1 class="pt-2 text-xs-right">
                        <v-btn  @click="hideAddCargoForm" small outline fab color="deep-orange lighten-1" slot="activator">
                            <v-icon >block</v-icon>
                        </v-btn>

                </v-flex>

            </v-layout>

        <add-cargo v-if="showForm"></add-cargo>

        <template v-if="cargos">
            <v-card flat v-for="cargo in cargos.data" :key="cargo.id">
                <v-layout row wrap class="pa-3 mb-1">
                    <v-flex xs12 md4>
                        <div class="caption grey--text">Nosaukums</div>
                        <div>{{cargo.name}}</div>
                    </v-flex>
                    <v-flex xs6 md3>
                        <div class="caption grey--text">UN Nummurs</div>
                        <div>{{cargo.un_nr ? cargo.un_nr : "N/A"}}</div>
                    </v-flex>
                    <v-flex xs6 md3>
                        <div class="caption grey--text">Mazgāšanas prog. nr.</div>
                        <div>{{cargo.cleaning_program ? cargo.cleaning_program : "N/A"}}</div>
                    </v-flex>

                    <v-flex xx12 sm4 md2>
                        <v-layout row wrap>
                            <v-flex xs6>
                                <v-tooltip top>
                                    <v-btn icon to="" flat small slot="activator">
                                        <v-icon color="grey">open_in_new</v-icon>
                                    </v-btn>
                                    <span>Skatīt kravu</span>
                                </v-tooltip>
                            </v-flex>
                            <v-flex xs6>
                                <v-tooltip top>
                                    <v-btn icon @click="deleteCargo(cargo.id)" flat small slot="activator">
                                        <v-icon color="grey">delete</v-icon>
                                    </v-btn>
                                    <span>Dzēst kravu</span>
                                </v-tooltip>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>

            <v-layout row>
                <v-flex v-if="cargos.meta.last_page > 1" sm6  offset-sm4>
                    <v-pagination
                            v-model="cargos.meta.current_page"
                            :length="cargos.meta.last_page"
                            :total-visible="5"
                            color="deep-purple accent-3"
                            @input="onPageChange"
                    ></v-pagination>
                </v-flex>
            </v-layout>
        </template>
        <v-snackbar
                v-model="snackbar"
                :color="color"
                :timeout="timeout"
                auto-height
                right
        >
            {{ text }}
            <v-btn dark
                   flat
                   @click="snackbar = false"
            >X</v-btn>
        </v-snackbar>

    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex'
    import AddCargo from "../components/AddCargo.vue";

    export default {
        name: "Cargos",
        components: {AddCargo},
        data: () => ({
            snackbar: false,
            color: '',
            timeout: 2000,
            text: ''
        }),
        mounted() {
            this.$store.dispatch('hideAddCargoForm')
            this.$store.dispatch('resetSearch')
            this.$store.dispatch('getCargos')
        },
        computed: {
            ...mapGetters({
                cargos: 'cargos',
                search: 'search',
                showForm: 'showAddCargoForm'
            })
        },
        methods: {
            searchCargos(value){
                this.$store.dispatch('changeSearch', value)
                this.$store.dispatch('getCargos')
            },
            onPageChange() {
                this.$store.dispatch('getCargos', this.cargos.meta.current_page);
            },
            showAddCargoForm(){
                this.$store.dispatch('showAddCargoForm')
            },
            hideAddCargoForm(){
                this.$store.dispatch('hideAddCargoForm')
            },
            deleteCargo(cargoId){
                if(confirm('Vai esi drošs?')){
                    this.$Progress.start()
                    this.$store.dispatch('deleteCargo', cargoId)
                    this.snackbar = true
                    this.color = 'red'
                    this.text = 'Krava dzēsta'
                }
            }



        }
    }
</script>

<style scoped>

</style>